import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrialSurvey() {
  const { token } = useParams();
  const [survey, setSurvey] = useState(null);
  const [answers, setAnswers] = useState({});
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/academy/trial-survey/${token}`)
      .then((r) => { setSurvey(r.data); if (r.data.already_responded) setDone(true); })
      .catch(() => setError("This survey link is invalid or has expired."));
  }, [token]);

  const submit = async () => {
    try {
      await axios.post(`${API}/academy/trial-survey/${token}`, { responses: answers });
      setDone(true);
    } catch (e) { setError("Could not submit. Please try again."); }
  };

  if (error) return <Wrap><p className="text-slate-600" data-testid="survey-error">{error}</p></Wrap>;
  if (!survey) return <Wrap><p className="text-slate-500">Loading…</p></Wrap>;
  if (done) return <Wrap><div className="text-center" data-testid="survey-thankyou"><div className="text-5xl mb-3">⚽</div><h2 className="text-xl font-bold text-emerald-600">Thank you!</h2><p className="text-slate-600 mt-2">We appreciate your feedback on {survey.child_name}'s trial.</p>
    <div className="mt-6 pt-6 border-t border-slate-200">
      <p className="text-slate-800 font-semibold">Ready to make it official?</p>
      <p className="text-slate-500 text-sm mt-1 mb-4">Secure {survey.child_name}'s place in the academy — spots fill up fast.</p>
      <a href="/academy/start-registration" data-testid="survey-register-cta" className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors">Register {survey.child_name} now →</a>
    </div>
  </div></Wrap>;

  return (
    <Wrap>
      <h1 className="text-2xl font-bold text-slate-800 mb-1">How was the trial?</h1>
      <p className="text-slate-500 mb-6">A quick minute on {survey.child_name}'s SCC Football Academy trial.</p>
      <div className="space-y-6">
        {survey.questions.map((q) => (
          <div key={q.id} data-testid={`survey-q-${q.id}`}>
            <label className="block font-medium text-slate-700 mb-2">{q.label}</label>
            {q.type === "rating" && (
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} onClick={() => setAnswers((a) => ({ ...a, [q.id]: n }))}
                    className={`w-11 h-11 rounded-full font-semibold ${answers[q.id] === n ? "bg-purple-600 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}
                    data-testid={`survey-${q.id}-${n}`}>{n}</button>
                ))}
              </div>
            )}
            {q.type === "choice" && (
              <div className="flex flex-wrap gap-2">
                {q.options.map((o) => (
                  <button key={o} onClick={() => setAnswers((a) => ({ ...a, [q.id]: o }))}
                    className={`px-4 py-2 rounded-lg ${answers[q.id] === o ? "bg-purple-600 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}
                    data-testid={`survey-${q.id}-${o}`}>{o}</button>
                ))}
              </div>
            )}
            {q.type === "text" && (
              <textarea rows={3} className="w-full border border-slate-300 rounded-lg p-3 text-slate-700"
                value={answers[q.id] || ""} onChange={(e) => setAnswers((a) => ({ ...a, [q.id]: e.target.value }))} data-testid={`survey-${q.id}-input`} />
            )}
          </div>
        ))}
        <button onClick={submit} className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg" data-testid="survey-submit">Submit feedback</button>
      </div>
    </Wrap>
  );
}

function Wrap({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 max-w-md w-full">{children}</div>
    </div>
  );
}
